<template>
  <div>
    <div class="mb-2 font-bold text-sm">Kriteria pengurangan stok (-):</div>
    <div>
      <ul class="stock-rule-list">
        <li>Pengambilan khusus seperti pengambilan snack oleh Agen dan kru</li>
        <li>Pengurangan snack karena snack rusak, hilang, atau kedaluwarsa</li>
        <li>Penjualan snack via Kondektur dan aplikasi Harapan Jaya Prima <span style="color: red; font-weight: 700;">tidak</span> termasuk dalam pengurangan stok snack karena otomatis dikurangi dari sistem</li>
      </ul>
    </div>
  </div>
</template>